import React, { useState } from "react";
import tw from "tailwind-styled-components";
import { Formik, Field, Form } from "formik";
import {
  InputGroup,
  FieldWrapper,
  Label,
  SubmitBtn,
  CombineInputGroup,
} from "../Styles/InputStyles";
import Loading from "../Loading";
import MenuItem from "@mui/material/MenuItem";
import Select from "react-select";
import Model from "../Model";
import DropzoneForContact from "../Contacts/DropzoneForContact";
import Images from "../../Images";
import { gDistrictsList, gRegionsList } from "../../Config";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import Config from "../../Config";

const AddRegionalRegisterarModel = ({
  SingleEntryLoading,
  postSingleEntry,
  setOpenUploadModel,
  hostNamesandProvince,
}) => {
  const [uploadFile, setUploadFile] = useState("");
  const [districtsList, setDistricts] = useState([]);
  const { t, i18n } = useTranslation();
  const InitialValues = {
    type: 7,
  };
if (Config.rdcDataFromBackend == 'Yes')
{
  // const gDynamicCouncils = useSelector(
  //   (state) => state?.CouncilsDataReducer?.councils
  // );

  // const gDynamicDistricts = useSelector(
  //   (state) => state?.DistrictsDataReducer?.districts
  // );
  // const gDynamicRegions = useSelector(
  //   (state) => state?.RegionsDataReducer?.regions
  // );

  // const SetDynamicDistricts = (value) => {
  //   console.log("SetDynamicDistricts");

  //   var districtOptions = gDynamicDistricts
  //     ?.filter((item) => item.region === value)
  //     .map((item) => ({
  //       name: item.name,
  //       id: item.id,
  //     }));
  //   setDistricts(districtOptions);
  // };
  // const RegionList = gDynamicRegions.map((item) => ({
  //   value: item.id,
  //   label: item.name,
  // }));
}
  const SubmitHandler = (values) => {
    if (!values.region) {
      toast.error("Please select region");
      return;
    }

    postSingleEntry(values);
  };

//if (Config.rdcDataFromBackend == 'No')
//{
  const SetDynamicDistricts = (value) => {
    setDistricts(gDistrictsList[value]);
  };
  const RegionList = gRegionsList.map((item) => ({
    value: item.id,
    label: item.name,
  }));
//}


  const DistrictList = districtsList.map((item) => ({
    value: item.id,
    label: item.name,
  }));





  const UserList = [
    { value: "2", label: "Finance" },
    // { value: "3", label: "Registrar" },
    { value: "4", label: "Ass. Registrar" },
    // { value: "Administrator", label: "Administrator" },
  ];

  return (
    <Model width={`w-11/12 max-w-lg `} setOpenModel={setOpenUploadModel}>
      <Title>Add Regional Registrar</Title>

      {SingleEntryLoading && <Loading />}

      {!SingleEntryLoading && (
        <Formik initialValues={InitialValues} onSubmit={SubmitHandler}>
          <Form>
            <Wrapper>
              <CombineInputGroup>
                <InputGroup>
                  <Label htmlFor="fName">First Name</Label>
                  <FieldWrapper>
                    <Field
                      name="fName"
                      id="fName"
                      autoComplete="off"
                      required
                    />
                  </FieldWrapper>
                </InputGroup>
                <InputGroup>
                  <Label htmlFor="lName">Last Name</Label>
                  <FieldWrapper>
                    <Field
                      name="lName"
                      id="lName"
                      autoComplete="off"
                      required
                    />
                  </FieldWrapper>
                </InputGroup>
              </CombineInputGroup>
              <CombineInputGroup>
                <InputGroup>
                  <Label htmlFor="email">Email</Label>
                  <FieldWrapper>
                    <Field
                      type="text"
                      name="email"
                      id="email"
                      autoComplete="off"
                      className="truncate"
                      required
                    />
                  </FieldWrapper>
                </InputGroup>

                <InputGroup>
                  <Label htmlFor="mobile">Phone Number</Label>
                  <FieldWrapper>
                    <Field
                      type="number"
                      name="mobile"
                      id="mobile"
                      autoComplete="off"
                      className="truncate"
                      required
                    />
                  </FieldWrapper>
                </InputGroup>
              </CombineInputGroup>
              <CombineInputGroup>
                {/* <InputGroup>
                  <Label htmlFor="type">User Type</Label>
                  <FieldWrapper $select={true}>
                    <Field required name="type" id="type" autoComplete="off">
                      {(props) => (
                        <Select
                          className="w-full h-full"
                          options={UserList}
                          onChange={(val) =>
                            props.form.setFieldValue("type", val.value)
                          }
                        />
                      )}
                    </Field>
                  </FieldWrapper>
                </InputGroup> */}

                <InputGroup>
                  <Label htmlFor="password">Password</Label>
                  <FieldWrapper>
                    <Field
                      type="password"
                      name="password"
                      id="password"
                      autoComplete="off"
                      className="truncate"
                      required
                    />
                  </FieldWrapper>
                </InputGroup>
              </CombineInputGroup>

              <CombineInputGroup>
                <InputGroup>
                  <Label htmlFor="region">{t("c_region")}</Label>
                  <FieldWrapper $select={true}>
                    <Field
                      required
                      name="region"
                      id="region"
                      autoComplete="off"
                    >
                      {(props) => (
                        <Select
                          className="w-full h-full"
                          options={RegionList}
                          onChange={(val) => {
                            SetDynamicDistricts(val.value);
                            props.form.setFieldValue("region", val.value);
                          }}
                        />
                      )}
                    </Field>
                  </FieldWrapper>
                </InputGroup>
                {/* <InputGroup>
                  <Label htmlFor="district">{t("C_District")}</Label>
                  <FieldWrapper $select={true}>
                    <Field
                      required
                      name="district"
                      id="district"
                      autoComplete="off"
                    >
                      {(props) => (
                        <Select
                          className="w-full h-full"
                          options={DistrictList}
                          onChange={(val) =>
                            props.form.setFieldValue(
                              "district",
                              val.value
                            )
                          }
                        />
                      )}
                    </Field>
                  </FieldWrapper>
                </InputGroup> */}
              </CombineInputGroup>
            </Wrapper>
            <BtnWrapper>
              <SubmitBtn type="submit">Add</SubmitBtn>
            </BtnWrapper>
          </Form>
        </Formik>
      )}
    </Model>
  );
};

const Wrapper = tw.div`
grid  gap-6 my-6 px-1`;
const SampleFile = tw.a` w-full pt-3 text-blue-500 underline text-sm text-center`;

const Title = tw.h1`text-lg md:text-xl font-medium text-center text-gray-800`;
const BtnWrapper = tw.div`flex justify-center items-center`;

export default AddRegionalRegisterarModel;
